import React from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaFutbol, FaVolleyballBall, FaBasketballBall, FaRunning } from 'react-icons/fa';
import { MdSportsHandball } from 'react-icons/md';
import SEO from '../components/SEO';
import "./Modalidades.css";
const Modalidades = () => {
  // Ensure translations are loaded
  const { t } = useTranslation();

  return (
    <div className="modalidades-page">
      <SEO titleKey="seo.sports.title" descriptionKey="seo.sports.description" />
      <div className="modalidades-container">
        <h1>{t('pages.sports.title')}</h1>
        <p>{t('pages.sports.subtitle')}</p>

        <div className="modalidades-list">
          <Link to="/football-coaching-software" className="modalidade-card-link">
            <div className="modalidade-card">
              <div className="icon-container football">
                <FaFutbol />
              </div>
              <h3>{t('pages.sports.football')}</h3>
              <p>{t('pages.sports.footballDesc')}</p>
            </div>
          </Link>
          <Link to="/futsal-coaching-software" className="modalidade-card-link">
            <div className="modalidade-card">
              <div className="icon-container futsal">
                <FaFutbol />
              </div>
              <h3>{t('pages.sports.futsal')}</h3>
              <p>{t('pages.sports.futsalDesc')}</p>
            </div>
          </Link>
          <Link to="/handball-coaching-software" className="modalidade-card-link">
            <div className="modalidade-card">
              <div className="icon-container handball">
                <MdSportsHandball />
              </div>
              <h3>{t('pages.sports.handball')}</h3>
              <p>{t('pages.sports.handballDesc')}</p>
            </div>
          </Link>
          <Link to="/volleyball-coaching-software" className="modalidade-card-link">
            <div className="modalidade-card">
              <div className="icon-container volleyball">
                <FaVolleyballBall />
              </div>
              <h3>{t('pages.sports.volleyball')}</h3>
              <p>{t('pages.sports.volleyballDesc')}</p>
            </div>
          </Link>
          <Link to="/basketball-coaching-software" className="modalidade-card-link">
            <div className="modalidade-card">
              <div className="icon-container basketball">
                <FaBasketballBall />
              </div>
              <h3>{t('pages.sports.basketball')}</h3>
              <p>{t('pages.sports.basketballDesc')}</p>
            </div>
          </Link>
        </div>

        <div className="cta">
          <p>{t('pages.sports.ctaText')}</p>
          <a href="/pricing" className="btn-preco">{t('pages.sports.ctaButton')}</a>
        </div>
      </div>


    </div>
  );
};

export default Modalidades;

